<ng-container *ngIf="!isXeroImportModeEnabled;else enabled_content">
    <form *ngIf="parent" class="cnt-column" style="align-items:center;">
        <ng-container *ngIf="disableScroll; else enableScroll">
            <newplan-start-form-body #startSimple>

            </newplan-start-form-body>
        </ng-container>
        <ng-template #enableScroll>
            <scrolldiv class="filler" style="width: 100%" [scrollerSize]="20" [navigatorSize]="14" [scrollVerticalIndent]="0" cls="lightScroll">
                <newplan-start-form-body #startSimple>

                </newplan-start-form-body>
            </scrolldiv>
        </ng-template>
    </form>
</ng-container>


<ng-template #enabled_content>
    <form class="cnt-column" style="align-items: stretch;height: 100%;">
        <div class="filler cnt-column">
            <scrolldiv #scroll class="filler" style="width: 100%;" [scrollerSize]="20" [navigatorSize]="14" [scrollVerticalIndent]="0" cls="lightScroll">
                <div style="position: relative">

                    <choose-company-form-body #companyForm [ngClass]="{'hiddenCls': activeId != 'company'}">

                    </choose-company-form-body>

                    <newplan-start-form-body-xero #startForm [ngClass]="{'hiddenCls': activeId != 'settings'}">

                    </newplan-start-form-body-xero>

                    <xi-2-profitloss-form-body #xi2Form [ngClass]="{'hiddenCls': activeId != 'profitloss-accounts'}" (onCOASaved)="onCOASaved($event)">

                    </xi-2-profitloss-form-body>

                    <xi-3-balancesheet-form-body #balanceForm [ngClass]="{'hiddenCls': activeId != 'balancesheet-accounts'}" (onCOASaved)="onCOASaved($event)">

                    </xi-3-balancesheet-form-body>

                    <xi-4-associations-form-body #xi4Form [ngClass]="{'hiddenCls': activeId != 'component-associations'}">

                    </xi-4-associations-form-body>

                </div>

            </scrolldiv>
            <div #saveClosePanePlace></div>
        </div>

        <div [height]="60" class="bottom-div cnt-row-centered" [ngClass]="{'hiddenCls': activeId == ''}" data-testid="xeroWizardMenuPanel">
            <div [width]="20"></div>
            <div class="xeroLogo-small" data-testid="xeroLogo"></div>
            <div [width]="10"></div>
            <div class="filler"></div>
            <div *ngFor="let item of bottomPaneData; let i = index"
                 class="cnt-row-centered itemCls"
                 [ngClass]="{'active': item.id == activeId}"
                 (click)="onActivate(item)"
                 attr.data-testid="xeroWizardBtn-{{item.id}}">
                <div class="circle h4Font b1Color">{{i+1}}</div><div [width]="5"></div><span class="txt h3Font filler">{{item.text}}</span>
            </div>
            <div class="filler"></div>
            <simple-btn #next
                    [horizontalPadding]="32"
                    [width]="121"
                    [backgroundFillCls]="'o2Background'"
                    [hoverFillCls]="'o1Background'"
                    [boxShadowCls]="'primary-shadow'"
                    [text]="nextText | translate"
                    data-testid="nextButton"
                    (click)="nextClick()"
                    [rightImgCls]="'next-arrow'"
                    [rightSpace]="5"
                    [textCls]="'large-btn-text'"
                    [height]="40"
                    [disabled]="!canContinue"
                    [cornerRadius]="50">
            </simple-btn>
            <div [width]="20"></div>
        </div>

    </form>
</ng-template>
